import React, { useState } from 'react';

const LocationPermissionModal = ({ isOpen, onAllow, onDeny, isLoading }) => {
  if (!isOpen) return null;

  return (
  <>
    <div className="fixed inset-0 bg-black/50 z-[9999]" onClick={onDeny} />
    
    <div className="fixed inset-0 flex items-center justify-center z-[10000] p-4">
      <div className="bg-white dark:bg-gray-900 rounded-xl shadow-xl max-w-sm w-full overflow-hidden">
        {/* Header */}
        <div className="relative px-5 pt-5 pb-3 text-center">
          <div className="mx-auto w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700 flex items-center justify-center mb-3 shadow-lg">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Enable Location</h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">For better rental experience</p>
        </div>

        {/* Benefits */}
        <div className="px-5 py-2 space-y-2">
          {['Show nearby products', 'Accurate delivery estimates', 'Better rental matches'].map((text, i) => (
            <div key={i} className="flex items-center gap-2.5">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2.5">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              <span className="text-xs text-gray-600 dark:text-gray-300">{text}</span>
            </div>
          ))}
        </div>

        {/* Privacy note */}
        <div className="mx-5 mt-3 mb-2 px-2.5 py-1.5 bg-gray-50 dark:bg-gray-800/50 rounded-md">
          <p className="text-[11px] text-gray-500 dark:text-gray-400 text-center">
            🔒 Private · Change anytime in settings
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-2 p-4 pt-2 border-t border-gray-100 dark:border-gray-800">
          <button
            onClick={onDeny}
            disabled={isLoading}
            className="flex-1 px-3 py-2 text-xs font-medium text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-800 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors disabled:opacity-50"
          >
            Not Now
          </button>
          <button
            onClick={onAllow}
            disabled={isLoading}
            className="flex-1 px-3 py-2 text-xs font-semibold text-white bg-gradient-to-r from-blue-600 to-blue-700 dark:from-blue-500 dark:to-blue-600 rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all disabled:opacity-50 flex items-center justify-center gap-2 shadow-sm"
          >
            {isLoading ? (
              <>
                <svg className="animate-spin h-3.5 w-3.5" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                </svg>
                Loading...
              </>
            ) : (
              <>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                Allow
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  </>
);
};

export default LocationPermissionModal;
